import type { ReactNode } from 'react'

import type { BadgeTone } from '@/lib/utils/badgeTone'
import { cn } from '@/lib/utils/cn'

export type { BadgeTone } from '@/lib/utils/badgeTone'

/**
 * 🚨 배지의 **텍스트는 서버 라벨(`statusLabel`) 그대로**, 색만 프런트가 매핑한다(설계 D6).
 * 서버가 라벨 문구를 바꾸면 화면이 자동으로 따라간다.
 */
const TONE_CLASS: Record<BadgeTone, string> = {
  success: 'bg-success-100 text-success-500',
  warning: 'bg-warning-100 text-warning-500',
  danger: 'bg-danger-100 text-danger-500',
  neutral: 'bg-slateish-200 text-slateish-600',
}

export function Badge({ tone, children }: { tone: BadgeTone; children: ReactNode }) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full px-2.5 py-1 text-xs font-medium',
        TONE_CLASS[tone]
      )}
    >
      {children}
    </span>
  )
}
